/**
 * 生徒画面小項目情報取得API
 */
import { Component, Vue } from 'vue-property-decorator'
import { ApiResponseCurriculumSUnit } from '@/models/apiResponses/curriculumSUnits'

@Component
export default class StudentCurriculumSUnitsApi extends Vue {
  /**
   * 生徒画面に表示する小項目情報を取得
   * @param curriculumSUnitId 小項目ID
   * @returns 生徒画面に表示する小項目情報
   */
  protected async getStudentCurriculumSUnit(curriculumSUnitId: number): Promise<ApiResponseCurriculumSUnit> {
    const { data }: { data: ApiResponseCurriculumSUnit } = await Vue.prototype.$http.httpWithToken
      .get(`/v2/student/curriculum_s_units/${curriculumSUnitId}`)
      .catch(() => ({ data: null }))

    return data
  }
}
